<template>
  <button class="hl-button" type="button">
    <span v-if="text !== ''" class="hl-button-text">{{ text }}</span>
    <v-progress-circular
      v-if="loading"
      color="var(--color-brand-100)"
      size="1.2rem"
      indeterminate
      :width="3"
    ></v-progress-circular>
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: 'HlBtn',
  props: {
    text: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.hl-button-text {
  padding-right: 2vw;
  font-size: 1.4rem;
  font-weight: 400;
}
.hl-button {
  border: none;
  color: var(--color-black);
  padding: 5px 8px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
}

.hl-button1:hover {
  background-color: var(--color-brand-300);
  color: var(--color-black);
}
</style>
